import type { ReactNode } from 'react'

import { TabNav, type TabItem } from './Tabs'

export interface SectionHeaderProps {
  title: string
  description?: ReactNode
  /** The section name above a sub-page title. */
  eyebrow?: string
  actions?: ReactNode
  tabs?: readonly TabItem[]
  activeTab?: string
}

/** A page's title block: the page's one `h1`, its context, and its section tabs. */
export function SectionHeader({ title, description, eyebrow, actions, tabs, activeTab }: SectionHeaderProps) {
  return (
    <header className="ci-section-header">
      <div className="ci-section-header__row">
        <div className="ci-section-header__titles">
          {eyebrow ? <p className="ci-section-header__eyebrow">{eyebrow}</p> : null}
          <h1 className="ci-section-header__title">{title}</h1>
          {description ? <p className="ci-section-header__description">{description}</p> : null}
        </div>
        {actions ? <div className="ci-section-header__actions">{actions}</div> : null}
      </div>
      {tabs && tabs.length > 0 ? (
        <TabNav label={`${eyebrow ?? title} pages`} items={tabs} active={activeTab} />
      ) : null}
    </header>
  )
}
